var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-container',{attrs:{"fluid":""}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"100%"},attrs:{"src":_vm.src,"page":i}})}),1)],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e03e40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/overview/help.vue
// module id = dybs
// module chunks = 1